import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./index.css";

const checkExist1 = setInterval(function() {
  if (document.getElementsByClassName("gm-svpc")[0]) {
    document.getElementsByClassName("gm-svpc")[0].style.display = "none";
    clearInterval(checkExist1);
  }
}, 100); // check every 100ms

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
